export default __webpack_public_path__ + "3d5e3be80a57013d54796da747ab6cdb.svg";